import React from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from './Login.styles';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Layout from '../Layout';
import { Link } from 'react-router-dom';
import iconEmail from '../../assets/icon-email.svg';
import iconKey from '../../assets/icon-key.svg';

function Login() {
  const [form] = useForm();

  const { onLogin, loading_user } = useContextHook(AuthContext, v => ({
    onLogin: v.onLogin,
    loading_user: v.loading_user,
    loading_user_google: v.loading_user_google,
  }));

  const handleSubmit = e => {
    const payload = {
      email: e?.email,
      password: e?.password,
    };
    onLogin(payload);
  };

  return (
    <>
      <Layout showTemplate={false}>
        <OnboardingTemplate>
          <FormContent>
            <div className="text-content">
              <div className="text-wrapper">
                <div className="heading-text">
                  <h1>Sign In</h1>
                </div>
                <div className="formWrapper">
                  <Form form={form} onSubmit={handleSubmit}>
                    <Form.Item
                      type="email"
                      rounded
                      lg
                      name="email"
                      placeholder="Enter your email address"
                      rules={[
                        {
                          required: true,
                          message: 'Email is Required',
                        },
                      ]}
                      prefix={<img src={iconEmail} alt="mail" width={24} height={24} />}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      type="password"
                      rounded
                      name="password"
                      placeholder="Enter password"
                      prefix={<img src={iconKey} alt="key" width={24} height={24} />}
                      rules={[
                        {
                          required: true,
                          message: 'Password is Required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>

                    <div className="btn-holder">
                      <Button loader={loading_user}>Continue</Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="footer">
                Don't have an account? <Link to="/sign-up">Sign Up</Link>{' '}
              </div>
            </div>
          </FormContent>
        </OnboardingTemplate>
      </Layout>
    </>
  );
}

export default Login;
